export default __webpack_public_path__ + "static/media/unpin.8613bc53.svg";